import { render, staticRenderFns } from "./MetalRegion.vue?vue&type=template&id=bbca12c2&scoped=true&"
import script from "./MetalRegion.vue?vue&type=script&lang=ts&"
export * from "./MetalRegion.vue?vue&type=script&lang=ts&"
import style0 from "./MetalRegion.vue?vue&type=style&index=0&id=bbca12c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbca12c2",
  null
  
)

export default component.exports